import { useRoute } from 'vue-router';
export default {
  props: ['isClose'],
  setup() {
    const route = useRoute();
    return {
      route
    };
  }
};